// biome-ignore lint/suspicious/noExplicitAny: loading external scripts
export const loadScript = <T = any>(
  src: string | { src: string; integrity?: string; crossorigin?: string },
  globalName = ""
): Promise<T> => {
  const description = typeof src === "string" ? { src } : src;
  const loading = loadScript;
  // @ts-expect-error
  // biome-ignore lint/suspicious/noExplicitAny: loading external scripts
  const get = () => (window as any)[globalName] || loading[description.src];
  // @ts-expect-error
  // biome-ignore lint/suspicious/noExplicitAny: loading external scripts
  // biome-ignore lint/suspicious/noAssignInExpressions: loading external scripts
  const set = (val: any) => (loading[description.src] = val);

  const cached = get();
  if (cached) {
    return Promise.resolve(cached);
  }

  return set(
    new Promise((resolve, reject) => {
      const script = document.createElement("script");
      Object.keys(description).forEach((attr) => {
        const val = description[attr as keyof typeof description];
        if (val) {
          script.setAttribute(attr, val);
        }
      });
      script.onload = resolve;
      script.onerror = (error) => {
        reject(error);
        set(null);
      };
      document.body.appendChild(script);
      // biome-ignore lint/suspicious/noExplicitAny: loading external scripts
    }).then(() => (window as any)[globalName])
  );
};
